"use strict";
/**
 * Created on 06 23 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link SupplierAgreementPricesRecalcInput}.
 *
 * @author JMe
 */


var SupplierAgreementPricesRecalcInputConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierAgreementPricesRecalcInputConverter, _DataObjectConverter_);

  function SupplierAgreementPricesRecalcInputConverter() {
    _classCallCheck(this, SupplierAgreementPricesRecalcInputConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementPricesRecalcInputConverter).apply(this, arguments));
  }

  return SupplierAgreementPricesRecalcInputConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierAgreementPricesRecalcInputConverter = SupplierAgreementPricesRecalcInputConverter;